<template>
  <b-modal ref="activityVersionsModal" :hide-header="true" :hide-footer="true" size="lg" :body-class="['p-0']" class="versions-modal" scrollable :no-close-on-backdrop="true">
    <div class="versions-modal__container p-25">
      <span class="version_heading">Versions</span>
      <img src="static/img/add.svg" class="rt-2-10 close-icon" @click="closeActivityVersionsModal" />
      <table class="table">
        <thead class="fs-12">
          <tr>
            <th class="border-top-0 version_width" scope="col">Number</th>
            <th class="border-top-0" scope="col">Comments</th>
            <th class="border-top-0" scope="col">Saved Date</th>
            <th class="border-top-0" scope="col">Modified By</th>
            <th class="border-top-0" scope="col">Modifications</th>
            <th class="border-top-0" scope="col">Version Status</th>
          </tr>
        </thead>
        <tbody :class="this.activityRevisionCount < 10 ? 'tbody.table-scroller' : 'versions-modal .table tbody'">
          <tr v-for="(revision, index) in activityRevisions" :key="index" :class="{ 'table-secondary': revision.revisionId === revisionId }">
            <th class="border-top-0 version_width" scope="row">
              {{ revision.version }}
            </th>
            <th class="border-top-0" scope="col">{{ revision.comment }}</th>
            <th class="border-top-0" scope="col">
              {{ revision.modifiedTime | formatDate }}
            </th>
            <th class="border-top-0" scope="col">{{ revision.modifiedBy }}</th>
            <th class="border-top-0" scope="col">
              <button v-if="revision.revisionId != revisionId" type="button" class="btn btn-default mr-6" @click="openActivityComparator(revision)">
                View Modifications
              </button>
            </th>
            <th class="border-top-0" scope="col">
              <button v-if="revision.revisionId != revisionId && showPushToLive" type="button" class="btn btn-default mr-6" @click="pushVersionLive(revision)">
                Push Live
              </button>
              <span v-else-if="revision.revisionId === revisionId" class="badge badge-light">Live</span>
            </th>
          </tr>
        </tbody>
      </table>
    </div>
  </b-modal>
</template>

<script>
import moment from "moment";
import toastr from "toastr";
import _ from "lodash";

export default {
  name: "ActivityVersionModal",
  props: {
    activityId: {
      type: String,
      default: null
    },
    // Revision ID of activity that is currently attached with study
    revisionId: {
      type: String,
      default: null
    },
    showPushToLive: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activityRevisions: null,
      activityRevisionCount: 0
    };
  },
  filters: {
    formatDate(value) {
      return moment(value).format("DD MMM YYYY hh:mm A z");
    }
  },
  watch: {
    activityId(v) {
      if (v) {
        this.open();
      }
    }
  },
  methods: {
    closeActivityVersionsModal() {
      this.$refs.activityVersionsModal.hide();
      this.$emit("close");
    },
    getActivityVersions(activityId) {
      this.$api.getActivityVersions(activityId).then(
        response => {
          this.activityRevisions = this.getSortedVersionHistory(response.data.result.rows);
          this.activityRevisionCount = this.activityRevisions.length;
          this.$refs.activityVersionsModal.show();
        },
        () => {
          this.closeActivityVersionsModal();
          toastr.error("Error while getting activity versions");
        }
      );
    },
    open() {
      this.getActivityVersions(this.activityId);
    },
    getSortedVersionHistory(activityVersionHistory) {
      return _.sortBy(activityVersionHistory, [
        function(o) {
          return _.parseInt(o.version);
        }
      ]).reverse();
    },

    openActivityComparator(targetActivity) {
      const sourceActivity = this.activityRevisions.find(activity => {
        return activity.revisionId === this.revisionId;
      });

      const targetActivityData = {
        activityId: targetActivity.activityId,
        revisionId: targetActivity.revisionId
      };
      const sourceActivityData = {
        activityId: sourceActivity.activityId,
        revisionId: sourceActivity.revisionId
      };

      this.$emit("onViewModifications", sourceActivityData, targetActivityData);
      this.closeActivityVersionsModal();
    },

    pushVersionLive(revision) {
      this.$emit("pushLive", revision);
    }
  }
};
</script>

<style lang="scss" scoped>
.versions-modal {
  position: absolute;
  z-index: 1040;
}
.versions-modal .table thead th {
  color: #b0bac9;
  font-weight: normal;
  font-family: Roboto-Medium;
  border-bottom: 1px solid #dee2e6;
}
.versions-modal .table tbody th {
  color: #000;
  font-weight: normal;
  font-family: Roboto-Medium;
}
.versions-modal .table tbody tr th {
  max-width: 450px;
}
.versions-modal .table tbody tr td:nth-child(2) {
  width: 250px;
}
.versions-modal .table tbody tr td:nth-child(3) {
  width: 250px;
}

.versions-modal .table tbody tr td:last-child {
  width: 230px;
}
.versions-modal .table .btn {
  height: 22px;
  font-size: 12px;
  padding: 0.1rem 0.5rem;
  background: #fff;
  border: 1px solid #ced4da;
  color: #4c8ce4;
}
.versions-modal .close-icon {
  position: absolute;
  right: 10px;
  top: 10px;
  cursor: pointer;
}
.version_heading {
  color: #666669;
  font-size: 16px;
  font-weight: bold;
}
tbody.tbody\.table-scroller {
  height: auto !important;
  border: 1px solid #ced4da;
  border-top: none !important;
}
tbody.versions-modal.\.table.tbody {
  height: 500px !important;
  position: unset !important;
  border: 1px solid #ced4da;
  border-top: none !important;
}
.versions-modal .table tbody {
  display: block;
  height: 500px;
  overflow: auto;
}
.versions-modal .table thead {
  display: block;
}
.versions-modal .table thead,
.versions-modal .table tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}
.versions-modal .table tbody tr th {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6 !important;
  border-bottom: none !important;
  color: #666769 !important;
}
th.border-top-0.version_width {
  width: 110px !important;
}
@media (min-width: 1024px) and (max-width: 1199px) {
  th.border-top-0.version_width {
    width: 80px !important;
  }
  .versions-modal .table tbody tr th {
    max-width: 80px;
  }
  .versions-modal .table tbody tr td:nth-child(2) {
    width: 180px;
  }
  .versions-modal .table tbody tr td:nth-child(3) {
    width: 180px;
  }
  .versions-modal .table tbody tr td:last-child {
    width: 200px;
  }
}
</style>
